import { render, staticRenderFns } from "./Product_released_warehouse_list.vue?vue&type=template&id=5705a0a4&scoped=true&"
import script from "./Product_released_warehouse_list.vue?vue&type=script&lang=js&"
export * from "./Product_released_warehouse_list.vue?vue&type=script&lang=js&"
import style0 from "./Product_released_warehouse_list.vue?vue&type=style&index=0&id=5705a0a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705a0a4",
  null
  
)

export default component.exports